
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";

interface NoEmployeesFoundProps {
  canAddEmployees: boolean;
  onAddEmployee: () => void;
}

export function NoEmployeesFound({ 
  canAddEmployees, 
  onAddEmployee 
}: NoEmployeesFoundProps) {
  return (
    <div className="flex flex-col items-center py-8">
      <h3 className="text-lg font-semibold">No employees found</h3>
      <p className="text-muted-foreground mt-2">
        This store doesn't have any employees yet.
      </p>
      {canAddEmployees && (
        <Button
          variant="outline"
          className="mt-4"
          onClick={onAddEmployee}
        >
          <Plus className="mr-2 h-4 w-4" />
          Add your first employee
        </Button>
      )}
    </div>
  );
}
